<template>
	<b-col class="content pd-0 adminStatistic">
		<b-tabs class="tabs-analytics" v-model="tabActive">
			<b-tab>
				<template v-slot:title>
					<span>{{ $t('adminAnalytics.listing') }}</span>
				</template>
				<div class="wrap-line-chart">
					<b-row class="analytic-title">
						<b-col cols="8">
							<h4>{{ $t('adminAnalytics.titleChart') }}</h4>
						</b-col>
						<b-col cols="4">
							<v-select
								class="analytic-type"
								:searchable="false"
								:clearable="false"
								:reduce="option => option.value"
								label="text"
								:options="optionType"
								v-model="analyticsType"
							></v-select>
						</b-col>
					</b-row>
					<div class="details">
						<div class="item">
							<div class="color" style="background: #36A2EB"></div>
							<span class="text">{{
								$t('adminAnalytics.chartOfListing.postPromotion')
							}}</span>
						</div>
						<div class="item">
							<div class="color" style="background: #FB6384"></div>
							<span class="text">{{
								$t('adminAnalytics.chartOfListing.freeAds')
							}}</span>
						</div>
					</div>
					<div class="line-chart">
						<LineChart
							:chartData="lineChartData"
							:options="chartOptions"
							:width="760"
							:height="380"
						/>
					</div>
					<b-row>
						<b-col cols="12">
							<div class="tips">
								<div class="title">{{ $t('analytics.trick') }}</div>
								<div class="des">
									{{ $t('analytics.trickDetail1') }}
									<a
										id="seukhaiAds"
										href="http://seukhai.com/ads"
										target="_blank"
										style="color:var(--projectPrimaryColor)"
										>{{ $t('analytics.trickDetail2') }}</a
									>
									{{ $t('analytics.and') }}
									<router-link id="faq" :to="$i18nRoute({ name: 'faq' })">{{
										$t('analytics.trickDetail3')
									}}</router-link>
									{{ $t('analytics.trickDetail4') }}
								</div>
							</div>
						</b-col>
					</b-row>
				</div>
			</b-tab>
			
			<b-tab>
				<template v-slot:title>
					<span>{{ $t('adminAnalytics.payment') }}</span>
				</template>
				<div class="wrap-line-chart">
					<b-row class="analytic-title">
						<b-col cols="8">
							<h4>{{ $t('adminAnalytics.titleChart') }}</h4>
						</b-col>
						<b-col cols="4">
							<v-select
								class="analytic-type"
								:searchable="false"
								:clearable="false"
								:reduce="option => option.value"
								label="text"
								:options="optionType"
								v-model="analyticsType"
							></v-select>
						</b-col>
					</b-row>
					<div class="details">
						<div class="item">
							<div class="color" style="background: #FB6384"></div>
							<span class="text">{{
								$t('adminAnalytics.chartOfPayment')
							}}</span>
						</div>
					</div>
					<div class="line-chart">
						<LineChart
							:chartData="lineChartData"
							:options="chartOptions"
							:width="760"
							:height="380"
						/>
					</div>
					<b-row>
						<b-col cols="12">
							<div class="tips">
								<div class="title">{{ $t('analytics.trick') }}</div>
								<div class="des">
									{{ $t('analytics.trickDetail1') }}
									<router-link to="/">{{
										$t('analytics.trickDetail2')
									}}</router-link>
									{{ $t('analytics.and') }}
									<router-link to="/">{{
										$t('analytics.trickDetail3')
									}}</router-link>
									{{ $t('analytics.trickDetail4') }}
								</div>
							</div>
						</b-col>
					</b-row>
				</div>
			</b-tab>
			<b-tab>
				<template v-slot:title>
					<span>{{$t('analytics.statistics')}}</span>
				</template>
				<div class="wrap-line-chart">
					<b-row class="analytic-title">
						<b-col cols="6">
						<h4>{{$t('adminAnalytics.titleChart')}}</h4>
						</b-col>
						<b-col cols="6">
							<div class="date-pickers">
								<datepicker
									class="date-input"
									:language="th"
									v-model="dateFrom"
								></datepicker>
								<div class="text">{{ $t('paymentHistory.to') }}</div>
								<datepicker
									class="date-input"
									:language="th"
									v-model="dateTo"
								></datepicker>
							
								<b-button 
								class="btn-search" id="fetchUserPayments" @click="getChart(2)">{{ $t('paymentHistory.search') }}</b-button>
							</div>
						</b-col>
					</b-row>
					
					<div class="line-chart" v-if="analytics" style="height:auto">
						<b-card-title>{{$t('Total Register User')}} </b-card-title>
						<b-card-sub-title>{{$t('Starting date')}} : <b>{{this.dateFrom | formatDate($router.currentRoute.params.lang)}}</b></b-card-sub-title>  <br>
						<b-card-sub-title>{{$t('End Date')}} : <b>{{ this.dateTo	| formatDate($router.currentRoute.params.lang)}}</b></b-card-sub-title> <br>
						<b-card-sub-title>{{$t('Users')}} : <b>{{this.analytics.registered_users}}</b></b-card-sub-title>
						<b-row class="my-3">
							<b-card-title>{{$t('Classifieds')}}</b-card-title>
							<b-table striped hover :items="classifiedsItems" :fields="classifiedsFields" show-empty dark responsive small  sticky-header> 
								<!-- <template #cell(noSubCategory)="row">
									{{row.item.noSubCategory}}
									<span class="text-right">
									<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-search">
									{{ row.detailsShowing ? 'Hide' : 'Show'}} 
									</b-button>
									</span>
								</template>
								<template #row-details="row">
									<b-card>
										<b-button size="sm" @click="row.toggleDetails" class="btn-search">Hide</b-button>
									</b-card>
								</template> -->
							</b-table>
						</b-row>
						<b-row class="my-3">
							<b-card-title>{{$t('Property')}}</b-card-title>
							<b-table striped hover :items="propertyItems" :fields="propertyFields" show-empty dark responsive small  sticky-header>
								<!-- <template #cell(noSubCategory)="row">
									{{row.item.noSubCategory}}
									<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-search">
									{{ row.detailsShowing ? 'Hide' : 'Show'}} 
									</b-button>
								</template>
								<template #row-details="row">
									<b-card>
										<b-button size="sm" @click="row.toggleDetails" class="btn-search">Hide</b-button>
									</b-card>
								</template> -->
							</b-table>
						</b-row>
						<b-row class="my-3">
								<b-button class="btn-search" style="width:300px" @click="downloadXcl()">
							Download Excel report</b-button>
							


							
						</b-row>
					</div>
				</div>
			</b-tab>
		</b-tabs>
		<b-overlay :show="loadingPage" no-wrap></b-overlay>
	</b-col>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

// import PieChart from "@/plugins/PieChart";
// import BarChart from "@/plugins/BarChart";
import LineChart from '@/plugins/LineChart';
import Datepicker from 'vuejs-datepicker';
import { en, th } from 'vuejs-datepicker/dist/locale';
const moment = require('moment');
const xlsx = require('json-as-xlsx')

export default {
	components: {
		LineChart,
		Datepicker,
		//BarChart
		//PieChart,
	},
	data() {
		return {
			
			en: en,
			th: th,
			loadingPage: false,
			chartOptions: {
				responsive: false,
				maintainAspectRatio: false,
				scales: {
					gridLines: {
						display: true
					},
					yAxes: [
						{
							id: 'line-one',
							type: 'linear',
							position: 'left',
							beginAtZero: true
						},
						{
							id: 'line-two',
							type: 'linear',
							position: 'right',
							beginAtZero: true
						}
					]
				},
				legend: {
					labels: {
						generateLabels: function(chart) {
							return '';
						}
					}
				}
			},
			lineChartData: {
				labels: [],
				datasets: []
			},
			lineChartDataV2: {
				labels: [
					'January',
					'February',
					'March',
					'April',
					'May',
					'June',
					'July',
					'Decembar'
				],
				datasets: [
					{
						fill: false,
						label: this.$t('Post a promotion'),
						borderColor: '#FB6384',
						pointBackgroundColor: '#FB6384',
						yAxisID: 'line-two',
						data: [-46, -63, 66, 19, 65, -23, 78]
					}
				]
			},
			optionType: [
				{
					value: 'Day',
					text: this.$t('adminAnalytics.daily')
				},
				{
					value: 'Week',
					text: this.$t('adminAnalytics.weekly')
				},
				{
					value: 'Month',
					text: this.$t('adminAnalytics.monthly')
				},
				{
					value: 'Year',
					text: this.$t('adminAnalytics.yearly')
				}
			],
			analyticsType: 'Day',
			tabActive: 0,
			dateFrom: null,
			dateTo: null,
			classifiedsFields: [
				{
					key: 'category_id',
					label: this.$t('Category Id'),
					sortable: true,
				},
				{
					key: 'category_name',
					label: this.$t('Category Name'),
					sortable: true,
					class: 'text-center' 
				},
				{
					key: 'noSubCategory',
					label: this.$t('No. Sub Category'),
					sortable: false,
					_showDetails:false,
					class: 'text-center' 
				},
				{
					key: 'total_listings',
					label: this.$t('Number of Listing'),
					sortable: true,
					class: 'text-center' 
				}
			],
			classifiedsItems: [
			],
			propertyFields: [
				{
					key: 'category_id',
					label: this.$t('Category Id'),
					sortable: true,
				},
				{
					key: 'category_name',
					label: this.$t('Category Name'),
					sortable: true,
					class: 'text-center' 
				},
				{
					key: 'noSubCategory',
					label: this.$t('No. Sub Category'),
					sortable: false,
					_showDetails:false,
					class: 'text-center' 
				},
				{
					key: 'total_listings',
					label: this.$t('Number of Listing'),
					sortable: true,
					class: 'text-center' 
				}
			],
			propertyItems: [
			],
			json_meta: [
			[{
			"key": "charset",
			"value": "utf-8"
			}]
			],
			xlsdata:[],
			dataForUser:[],
			dataForExcel:[]
		};
	},
	watch: {
		analytics: function(val) {
			if (val) {
				if (!this.tabActive) {
					this.lineChartData = {
						labels: val.labels,
						datasets: [
							{
								fill: false,
								label: this.$t('adminAnalytics.chartOfListing.postPromotion'),
								borderColor: '#36A2EB',
								pointBackgroundColor: '#36A2EB',
								yAxisID: 'line-one',
								data: val.listingsPaid
							},
							{
								fill: false,
								label: this.$t('adminAnalytics.chartOfListing.freeAds'),
								borderColor: '#FB6384',
								pointBackgroundColor: '#FB6384',
								yAxisID: 'line-two',
								data: val.listingsFree
							}
						]
					};
				} else if(this.tabActive==2){
					console.log('val',val)
					this.classifiedsItems=[];
					this.propertyItems=[];
					val.total_listings_classified.forEach((val)=>{
						this.classifiedsItems.push(
							{
								category_id:val.category_id,
								category_name:val.category_name,
								noSubCategory:val.children.length,
								total_listings:val.total_listings
							}
						)
					})
					val.total_listings_property.forEach((val)=>{
						this.propertyItems.push(
							{
								category_id:val.category_id,
								category_name:val.category_name,
								noSubCategory:val.children.length,
								total_listings:val.total_listings
							}
						)
					})
					
				}else {
					this.lineChartData = {
						labels: val.labels,
						datasets: [
							{
								fill: false,
								label: this.$t('adminAnalytics.chartOfPayment'),
								borderColor: '#FB6384',
								pointBackgroundColor: '#FB6384',
								data: val.data
							}
						]
					};
				}
			}
		},
		analyticsType: function(val) {
			this.getChart(this.tabActive);
		},
		tabActive: function(val) {
			this.analyticsType = 'Day';
			this.getChart(val);
		}
	},
	mounted: function() {
		let date = new Date();
		this.dateFrom = new Date(date.setMonth(date.getMonth() - 1));
		this.dateTo = new Date();
	},
	filters: {
		formatDate(value, lang) {
			if (!value) return;
			let now = moment(new Date());
			let newVal = moment(value);
			// if (now.isSame(newVal, "day")) return;
			return moment(value)
				.local('th')
				.format('YYYY-DD-MM');
		},
		formatHour(value, lang) {
			if (!value) return;
			return moment(value)
				.local('th')
				.format('HH:mm');
		}
	},
	computed: {
		...mapGetters('AdminAnalyticsController', ['analytics'])
	},
	created() {
		this.getChart(this.tabActive);
	},
	methods: {
		...mapActions('AdminAnalyticsController', [
			'ADMIN_GET_ANALYTICS_LISTING',
			'ADMIN_GET_ANALYTICS_PAYMENT',
			'ADMIN_GET_ANALYTICS',
			'ADMIN_GET_DAILY_ANALYTICS'
		]),
		getChart(type = 0) {
			this.loadingPage = true;
			if (type == 1) {
				this.ADMIN_GET_ANALYTICS_PAYMENT({ type: this.analyticsType })
					.then(result => {
						this.loadingPage = false;
					})
					.catch(err => {
						this.loadingPage = false;
					});
			} else if(type == 2){
					this.ADMIN_GET_ANALYTICS({ from: this.dateFrom, to:this.dateTo  })
					.then(result => {
						this.loadingPage = false;
					})
					.catch(err => {
						this.loadingPage = false;
					});
					this.ADMIN_GET_DAILY_ANALYTICS({ from: this.dateFrom, to:this.dateTo  })
					.then(result => {
						console.log("result",result)
						this.xlsdata=[]
						let a=[],b=[],c=[]
						if(result.data.data.registered_users_daily){
							
							result.data.data.registered_users_daily.forEach((elemnt)=>{
								a.push({ created_date: elemnt.created_date, total_users: elemnt.total_users })
								this.$forceUpdate()
							})
							console.log("a",a)
							this.xlsdata.push({
									sheet: 'Users',
									columns: [
									{ label: 'Created Date', value: 'created_date' }, // Top level data
									{ label: 'Total Users', value: 'total_users' }, // Run functions
									],
									content: a
								})
						}
						if(result.data.data.total_listings_classified_daily.length){
							
							
							result.data.data.total_listings_classified_daily.forEach((elemnt)=>{
							
								b.push({ 
									'parent_id':elemnt.parent_id,
									'parent_name':elemnt.parent_name,
									'category_id': elemnt.category_id, 
									'category_name': elemnt.category_name,
									'created_date':elemnt.created_date,
									'total_listings':elemnt.total_listings 
								})
								this.$forceUpdate()
							})
							this.xlsdata.push({
									sheet: 'Classified',
									columns: [
									{ label: 'Main Category id', value: 'parent_id' }, // Top level data
									{ label: 'Main Category Name', value: 'parent_name' }, // Top level data
									{ label: 'Sub Category id', value: 'category_id' }, // Top level data
									{ label: 'Category name', value: 'category_name' }, // Run functions
									{ label: 'Created date', value: 'created_date' }, // Run functions
									{ label: 'Total listings', value: 'total_listings' }, // Run functions
									],
									content: b
								})
						}
						if(result.data.data.total_listings_property_daily.length){
							result.data.data.total_listings_property_daily.forEach((elemnt)=>{
								c.push({ 
									'parent_id':elemnt.parent_id,
									'parent_name':elemnt.parent_name,
									'category_id': elemnt.category_id, 
									'category_name': elemnt.category_name,
									'created_date':elemnt.created_date,
									'total_listings':elemnt.total_listings 
								})
								this.$forceUpdate()
									this.$forceUpdate()
							})
							this.xlsdata.push({
									sheet: 'Property',
									columns: [
									{ label: 'Main Category id', value: 'parent_id' }, // Top level data
									{ label: 'Main Category Name', value: 'parent_name' }, // Top level data
									{ label: 'Sub Category id', value: 'category_id' }, // Top level data
									{ label: 'Category name', value: 'category_name' }, // Run functions
									{ label: 'Created date', value: 'created_date' }, // Run functions
									{ label: 'Total listings', value: 'total_listings' }, // Run functions
									],
									content: c
								})
						}
						this.loadingPage = false;
					})
					.catch(err => {
						this.loadingPage = false;
					});
			}else {
				this.ADMIN_GET_ANALYTICS_LISTING({ type: this.analyticsType })
				.then(result => {
					this.loadingPage = false;
				})
				.catch(err => {
					this.loadingPage = false;
				});
			}
		},
		startDownload(ev){
			console.log("ev startDownload",this.dataForExcel)
		},
		finishDownload(ev){
			console.log("ev finishDownload",this.dataForExcel)
		},
		downloadXcl(){
			let settings = {
				fileName: `${moment(this.dateFrom).format('dd/MMM/YYYY')} - ${moment(this.dateTo).format('dd/MMM/YYYY')}`, // Name of the spreadsheet
				extraLength: 6, // A bigger number means that columns will be wider
				writeOptions: {} // Style options from https://github.com/SheetJS/sheetjs#writing-options
			}
			console.log("this.xlsdata",this.xlsdata)
			xlsx(this.xlsdata, settings)
		}
	}
};
</script>
<style lang="scss">
@import 'adminStatistic.scss';
</style>
